exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2MKR0zwd{list-style:none;padding-left:0}._1tNDH3EN{padding:4px 0;margin:0;display:inline-block;width:100%}._1fWMwfpt ._3oMUVxkD{height:80px;display:inline-block;width:100%;background-size:contain;background-repeat:no-repeat}", ""]);

// exports
exports.locals = {
	"data-list-chat-container": "_2MKR0zwd",
	"data-list-chat-data-list-chat-container": "_1tNDH3EN",
	"no-items-container": "_1fWMwfpt",
	"img-container": "_3oMUVxkD"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/notechat/notechatdatalist/datalistchat/style.less
// module id = 1118
// module chunks = 1 2